require('./_admin-bar');
require('./contract-batch');
require('./contract-batch-import');
require('./contract-batch-kas-import');
require('../debug');

// branch_admin
document.addEventListener('DOMContentLoaded', function () {

    let oldPartnerNr = '';

    $('#is_branch_admin').on('change', function () {
        if ($(this).is(':checked'))
        {
            oldPartnerNr = $('#partnernr').val();
            $('#partnernr').val('*').attr('readonly', true);
        }
        else
        {
            $('#partnernr').val(oldPartnerNr).attr('readonly', false);
        }
    });

});